<template>
  <a-modal :title="$t('增加阶梯库存')" :visible="open" :confirm-loading="loading" @ok="submit" @cancel="open = false">
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{span:6}" :wrapper-col="{span:16}">
      <a-form-model-item :label="$t('活动名称')"><span>{{ activityName }}</span></a-form-model-item>
      <a-form-model-item :label="$t('活动阶梯')" prop="tierId">
        <a-select v-model="form.tierId" :placeholder="$t('请选择活动阶梯')">
          <a-select-option v-for="tier in tiers" :key="tier.id" :value="tier.id">{{ $t('满') }} {{ tier.thresholdAmount }} ({{ $t('剩余') }} {{ tier.remainingStock }})</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('增加数量')" prop="quantity"><a-input-number v-model="form.quantity" :min="1" :precision="0" style="width:100%" /></a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { getFullGift, increaseFullGiftStock } from '@/api/activity/fullGift'

export default {
  name: 'IncreaseStockForm',
  data () {
    return {
      open: false,
      loading: false,
      activityName: '',
      tiers: [],
      form: { tierId: undefined, quantity: 1 },
      rules: {
        tierId: [{ required: true, message: this.$t('请选择活动阶梯'), trigger: 'change' }],
        quantity: [{ required: true, message: this.$t('请输入增加数量'), trigger: 'change' }]
      }
    }
  },
  methods: {
    async show (row) {
      const response = await getFullGift({ id: row.id })
      this.activityName = row.name
      this.tiers = response.data.tiers || []
      this.form = { tierId: this.tiers.length === 1 ? this.tiers[0].id : undefined, quantity: 1 }
      this.open = true
    },
    submit () {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          await increaseFullGiftStock(this.form)
          this.$message.success(this.$t('库存增加成功'))
          this.open = false
          this.$emit('ok')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>
